import { render, staticRenderFns } from "./DashboardSettingsPage.vue?vue&type=template&id=4b2bf841&scoped=true&lang=pug&"
import script from "./DashboardSettingsPage.vue?vue&type=script&lang=ts&"
export * from "./DashboardSettingsPage.vue?vue&type=script&lang=ts&"
import style0 from "./DashboardSettingsPage.vue?vue&type=style&index=0&id=4b2bf841&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b2bf841",
  null
  
)

export default component.exports